<template>
  <div class="container_introduce safe_container">
    <div class="safe_banner"></div>
    <div class="assessment_m">
      <div class="elementary">
        <div class="assessment_title">初级安全评估</div>
        <div class="assessment_step">下发文件</div>
        <div class="assessment_content">
          <div>安全评估报告（ 初级 ）</div>
          <div>安全评估证书（ 初级 ）</div>
        </div>
        <img class="line_img"
             src="@/assets/images/line.png"
             alt="">
        <div class="assessment_step">评估项目</div>
        <div class="assessment_content">
          <div>（ 线上 ）</div>
          <div>安全检测</div>
          <div>隐私检测</div>
          <div>合规审核</div>
        </div>
        <img class="line_img"
             src="@/assets/images/line.png"
             alt="">
        <div class="assessment_step">优势</div>
        <div class="assessment_content">
          <div>加快商店上架速度</div>
          <div>规避程序安全隐患</div>
        </div>
        <div class="go_assessment disabled-btn">
          立即评估
          <!-- <router-link :to="{name: 'uploadPackage'}">立即评估</router-link> -->
        </div>
      </div>
      <div class="senior">
        <div class="assessment_title">高级安全评估</div>
        <div class="assessment_step">下发文件</div>
        <div class="assessment_content">
          <div>安全评估报告（ 高级 ）</div>
          <div>安全评估证书（ 高级 ）</div>
        </div>
        <img class="line_img"
             src="@/assets/images/line.png"
             alt="">
        <div class="assessment_step">评估项目</div>
        <div class="assessment_content">
          <div><span>（ 线上 ）</span><span class="brackets">（ 线下 - 评估机构 ）</span></div>
          <div><span>安全检测</span><span>人工走访</span></div>
          <div><span>隐私检测</span><span>技术咨询</span></div>
          <div><span>合规审核</span><span>专家评估</span></div>
        </div>
        <img class="line_img"
             src="@/assets/images/line.png"
             alt="">
        <div class="assessment_step">优势</div>
        <div class="assessment_content">
          <div><span>加快商店上架速度</span><span>技术专家全程指导</span></div>
          <div><span>规避程序安全隐患</span><span>权威机构评估认证</span></div>
          <div><span></span><span>降低监管下架风险</span></div>
        </div>
        <div class="go_assessment disabled-btn">立即评估</div>
      </div>
    </div>
    <div class="introduce_title">安全评估流程</div>
    <div class="flow_path">
      <div class="create_m mr20">
        <div class="flow_cricle">
          1
        </div>
        <div class="flow_title">创建应用ID</div>
      </div>
      <div class="submit_m mr20">
        <div class="flow_cricle">
          2
        </div>
        <div class="flow_title">在线支付</div>
      </div>
      <div class="verification_m mr20">
        <div class="flow_cricle">
          3
        </div>
        <div class="flow_title">填写资料</div>
      </div>
      <div class="result_m  mr20">
        <div class="flow_cricle">
          4
        </div>
        <div class="flow_title">审核评估</div>
      </div>
      <div class="success_m">
        <div class="flow_cricle">
          5
        </div>
        <div class="flow_title">获取证书</div>
      </div>
    </div>
    <div class="introduce_title">什么是安全评估</div>
    <div class="real_introduce">
      <p>具有舆论属性或社会动员能力的互联网信息服务安全评估是对用于具有舆论属性或社会动员能力的互联网信息服务的业务平台、业务功能、业务信息内容等方面的安全性进行全面的识别与分析，是运用通过科学的手段识别客观存在于业务平台、功能、信息以及支撑系统中的安全风险。</p>
      <p>安全评估工作重点从相关应用的程序安全、隐私权限、用户信息等3个维度开展。从违法有害信息内容监测、处置和溯源能力以及移动应用运营者的安全管理能力等多角度进行检查和评估。</p>
    </div>
    <div class="introduce_title">服务内容详细介绍</div>
    <div class="serve_detail">
      <div class="tabs">
        <div @click="cur=1"
             :class="{active:cur==1}">
          <img class="mt15"
               :src="cur==1?require('@/assets/images/moshi_light.png'):require('@/assets/images/moshi.png')"
               alt="">
          <div class="mt12">评估模式</div>
          <!-- <img class="mt12"
               src="@/assets/images/sanjiao.png"
               alt=""
               v-if="cur==1"> -->
        </div>
        <div @click="cur=2"
             :class="{active:cur==2}">
          <img class="mt15"
               :src="cur==2?require('@/assets/images/content_light.png'):require('@/assets/images/content.png')"
               alt="">
          <div class="mt12">评估内容</div>
          <!-- <img class="mt12"
               src="@/assets/images/sanjiao.png"
               alt=""
               v-if="cur==2"> -->
        </div>
      </div>
      <div v-if="cur==1"
           class="evaluation_mode ">
        <div class="evaluation_m">
          <div class="evaluation_title">线上+线上模式结合</div>
          <div class="evaluation_detail"
               style="display: block; width: 100%;font-size: 12px;transform: scale(0.9);line-height: 22px; margin-left:0;">
            <div>线上申请，完成资料提交和初审</div>
            <div>线下评估，线下访谈与专家一对一指导</div>
          </div>
        </div>
      </div>
      <div v-if="cur==2"
           class="evaluation_content">
        <div class="evaluation">
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">安全评估与咨询</div>
            <div class="evaluation_detail">
              <div>调研用户相关业务，分析用户系统安全状况；</div>
              <div>全面评估用户业务的信息安全及其安全措施与安全管理能力；</div>
              <div>技术专家随时指导安全建设与管理。</div>
            </div>

          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">安全漏洞管理</div>
            <div class="evaluation_detail">
              <div>漏洞修复指导，保证漏洞修复效果；</div>
              <div>高危漏洞预警，第一时间了解漏洞信息，防患于未然。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">安全加固指导</div>
            <div class="evaluation_detail">
              <div>基于最佳安全实践，结合用户业务现状，量身定制安全保障体系；</div>
              <div>指导用户进行安全风险管理，合理控制安全风险。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">安全应急响应</div>
            <div class="evaluation_detail">
              <div>定期扫描系统、应用层安全漏洞，及时发现安全隐患；</div>
              <div>漏洞修复指导，保证漏洞修复效果；</div>
              <div>高危漏洞预警，第一时间了解漏洞信息，防患于未然。</div>
            </div>

          </div>
        </div>
        <div class="evaluation">
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">用户信息留存、管理机制</div>
            <div class="evaluation_detail">
              <div>分析用户息的留存管理机制，根据要求评估合规性；</div>
              <div>提出合理建议，并指导客户完成改造。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">用户身份信息核验措施</div>
            <div class="evaluation_detail">
              <div>检查是否设置用户实名认证；</div>
              <div>检查实名认证方式与核验接口的合规性。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">操作日志的管理机制</div>
            <div class="evaluation_detail">
              <div>检查是否设有用户的账号、操作时间、操作类型、网络源地址和目标地址、网络源端口、客户端硬件特征等日志信息的留存措施；</div>
              <div>根据合规要求提出合理建议。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">违法有害信息防护措施</div>
            <div class="evaluation_detail">
              <div>分析用户信息的防护处置与技术措施；</div>
              <div>检查是否设置个人信息保护以及防范违法有害信息的传播扩散、社会动员功能失控风险的技术措施，并提出合理建议。</div>
            </div>

          </div>
        </div>
        <div class="evaluation">
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">安全管理机构评估</div>
            <div class="evaluation_detail">
              <div>检查企业内部是否设置安全管理机构；</div>
              <div>评估相应管理能力和管理人员职责分配的合理性；</div>
            </div>

          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">投诉举报机制检查</div>
            <div class="evaluation_detail">
              <div>检查是否建立用户投诉举报接收处理制度；</div>
              <div>评估举报投诉机制的应用合理合规性。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
            <div class="evaluation_title">监管协作机制检查</div>
            <div class="evaluation_detail">
              <div>检查同公安部门建立涉嫌违法犯罪线索、异常情况报告、安全提示和案件调查配合制度；</div>
              <div>评估制度的实际操作性与可能存在的问题，给出合理建议并帮助完成改造。</div>
            </div>
          </div>
          <div class="evaluation_m evaluation_flex">
          </div>
        </div>
      </div>
    </div>
    <div class="introduce_title">我的优势</div>
    <div class="advantage">
      <div class="advantage_m mr45">
        <div class="advantage_title">
          <div class="pt20">专业团队</div>
          <img src="@/assets/images/tuandui.png"
               alt=""
               class="advantage_img">
        </div>
        <div class="advantage_content">
          <div class="pt50">经验丰富的安全专家为用户服务，全面解决用户安全痛点。</div>
        </div>
      </div>
      <div class="advantage_m mr45">
        <div class="advantage_title">
          <div class="pt20">全面深入</div>
          <img src="@/assets/images/shenru.png"
               alt=""
               class="advantage_img">
        </div>
        <div class="advantage_content">
          <div class="pt50">深入用户业务，贴近用户需求，快速安全分析，全面深度检测。</div>
        </div>
      </div>
      <div class="advantage_m mr45">
        <div class="advantage_title">
          <div class="pt20">经验丰富</div>
          <img src="@/assets/images/fengfu.png"
               alt=""
               class="advantage_img">
        </div>
        <div class="advantage_content">
          <div class="pt50">基于丰富的安全实践经验，满足用户多种安全需求。</div>
        </div>
      </div>
      <div class="advantage_m">
        <div class="advantage_title">
          <div class="pt20">节约成本</div>
          <img src="@/assets/images/jieyue.png"
               alt=""
               class="advantage_img">
        </div>
        <div class="advantage_content">
          <div class="pt50">节约人力资源投入，最大化安全投资效益</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      cur: 1
    }
  },
  beforeRouteEnter (to, from, next) {
    next({ name: from.name || 'overview' })
  }
}
</script>
<style  lang="less" scoped >
//安全评估介绍页
.safe_container {
  max-width: 1140px;
  margin: 10px auto 0;
  box-sizing: border-box;
  .safe_banner {
    width: 100%;
    height: 309px;
    background-image: url(~@/assets/images/safe.png);
  }
  .assessment_m {
    width: 100%;
    margin: 60px 0 50px 0;
    display: flex;
    .elementary,
    .senior {
      border-radius: 3px;
      height: 550px;
      background: #f6f7f7;
      flex: 1;
      text-align: center;
      position: relative;
      .assessment_title {
        font-size: 22px;
        color: #333;
        margin: 25px 0;
      }
      .assessment_step {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .assessment_content > div {
        font-size: 16px;
        color: #333;
        line-height: 24px;
        display: flex;
        flex-direction: row;
        text-align: center;
        justify-content: center;
        span {
          flex: 1;
        }
        span:nth-child(1) {
          text-align: right;
          margin-right: 28px;
        }
        span:nth-child(2) {
          text-align: left;
        }
        .brackets {
          margin-left: -20px;
        }
      }
      .line_img {
        margin: 10px 0;
      }
      .go_assessment {
        height: 66px;
        line-height: 66px;
        color: #fff;
        font-size: 21px;
        background: #2d9939;
        border: 1px solid #2d9939;
        position: absolute;
        bottom: 0;
        width: 100%;
        border-radius: 0 0 3px 3px;
        a {
          display: block;
        }
      }
    }
    .elementary {
      margin-right: 80px;
    }
  }
  .serve_detail {
    margin-bottom: 50px;
    .tabs {
      font-size: 20px;
      color: #6c8377;
      font-weight: bold;
      height: 140px;
      width: 460px;
      margin: 0 auto;
      .active {
        color: #2d9939;
        &::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: -10px;
          width: 0;
          height: 0;
          display: block;
          margin-left: -8px;
          border: 8px solid transparent;
          border-bottom-color: #f6f7f7;
          border-left-color: #f6f7f7;
          transform: rotate(135deg);
          box-shadow: -1px 1px 1px 0px #dddddd;
        }
      }
    }
    .tabs > div {
      width: 230px;
      height: 140px;
      float: left;
      text-align: center;
      position: relative;
    }
    .evaluation_mode {
      height: 140px;
      background: #f6f7f7;
      text-align: center;
      border: 1px solid #dddddd;
    }
    .evaluation_content {
      // height: 610px;
      padding-bottom: 30px;
      background: #f6f7f7;
      border: 1px solid #dddddd;
      .evaluation {
        display: flex;
        flex-direction: row;
        margin-right: 50px;
        .evaluation_flex {
          flex: 1;
          margin-left: 50px;
        }
      }
    }
    .evaluation_m {
      color: #333;
      .evaluation_title {
        font-size: 16px;
        font-weight: bold;
        padding-top: 35px;
        margin-bottom: 15px;
      }
      .evaluation_detail {
        font-size: 12px;
        transform: scale(0.9);
        width: 110%;
        margin-left: -14px;
        line-height: 22px;
      }
    }
  }
}
</style>
